import React, { useState } from "react";
import { getCallBack } from "../../api/api";
import rbdLogo from "../../Assets/logo.png";
import toast from "react-hot-toast";

export default function CallbackModal({ onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
    comment: "",
  });

  const [errors, setErrors] = useState({
    name: "",
    mobile: "",
    email: "",
    comment: "",
  });

  const [touched, setTouched] = useState({
    name: false,
    mobile: false,
    email: false,
    comment: false,
  });

  const [successModal, setSuccessModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Validation functions
  const validateName = (name) => {
    if (!name.trim()) {
      return "Name is required";
    }
    if (name.trim().length < 2) {
      return "Name must be at least 2 characters";
    }
    if (!/^[a-zA-Z\s]+$/.test(name)) {
      return "Name should only contain letters";
    }
    return "";
  };

  const validateMobile = (mobile) => {
    if (!mobile) {
      return "Mobile number is required";
    }
    if (mobile.length !== 10) {
      return "Mobile number must be exactly 10 digits";
    }
    if (!/^[6-9]\d{9}$/.test(mobile)) {
      return "Please enter a valid Indian mobile number";
    }
    return "";
  };

  const validateEmail = (email) => {
    if (!email.trim()) {
      return "Email is required";
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      return "Please enter a valid email address";
    }
    return "";
  };

  const validateComment = (comment) => {
    if (!comment.trim()) {
      return "Comment is required";
    }
    if (comment.trim().length < 10) {
      return "Comment must be at least 10 characters";
    }
    return "";
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    let updatedValue = value;
    if (name === "mobile") {
      updatedValue = value.replace(/\D/g, "");
    }

    setFormData({ ...formData, [name]: updatedValue });

    // Validate on change if field has been touched
    if (touched[name]) {
      let error = "";
      switch (name) {
        case "name":
          error = validateName(updatedValue);
          break;
        case "mobile":
          error = validateMobile(updatedValue);
          break;
        case "email":
          error = validateEmail(updatedValue);
          break;
        case "comment":
          error = validateComment(updatedValue);
          break;
        default:
          break;
      }
      setErrors({ ...errors, [name]: error });
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    
    setTouched({ ...touched, [name]: true });

    let error = "";
    switch (name) {
      case "name":
        error = validateName(value);
        break;
      case "mobile":
        error = validateMobile(value);
        break;
      case "email":
        error = validateEmail(value);
        break;
      case "comment":
        error = validateComment(value);
        break;
      default:
        break;
    }
    setErrors({ ...errors, [name]: error });
  };

  const handleReset = () => {
    setFormData({ name: "", mobile: "", email: "", comment: "" });
    setErrors({ name: "", mobile: "", email: "", comment: "" });
    setTouched({ name: false, mobile: false, email: false, comment: false });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate all fields
    const nameError = validateName(formData.name);
    const mobileError = validateMobile(formData.mobile);
    const emailError = validateEmail(formData.email);
    const commentError = validateComment(formData.comment);

    const newErrors = {
      name: nameError,
      mobile: mobileError,
      email: emailError,
      comment: commentError,
    };

    setErrors(newErrors);
    setTouched({ name: true, mobile: true, email: true, comment: true });

    // Check if there are any errors
    if (nameError || mobileError || emailError || commentError) {
      toast.error("Please fix all errors before submitting");
      return;
    }

    const nameParts = formData.name.trim().split(" ");
    const first_name = nameParts[0] || "";
    const last_name = nameParts.slice(1).join(" ") || "";

    const payload = {
      first_name,
      last_name,
      phone_number: formData.mobile,
      email: formData.email,
      comment: formData.comment,
      prescription: "",
    };

    try {
      setIsSubmitting(true);
      const response = await getCallBack(payload);
      console.log("Form submitted successfully:", response);
      handleReset();
      setSuccessModal(true);
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error(error?.response?.data?.message || error?.message || "Failed to submit form");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputStyle = (hasError) => ({
    width: "100%",
    padding: "8px",
    border: `1px solid ${hasError ? "#ff0000" : "#ccc"}`,
    borderRadius: "4px",
    // marginBottom: "5px",
    boxSizing: "border-box",
    outline: hasError ? "none" : undefined,
  });

  const errorStyle = {
    color: "#ff0000",
    fontSize: "12px",
    marginBottom: "10px",
    marginTop: "0px",
    display: "block",
    minHeight: "18px",
  };

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
      }}
    >
      <div
        style={{
          background: "#cbe8e4ff",
          borderRadius: "8px",
          padding: "30px 30px 25px 30px",
          width: "90%",
          maxWidth: "450px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
          position: "relative",
          fontFamily: "Arial, sans-serif",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            right: "15px",
            top: "15px",
            background: "transparent",
            border: "none",
            fontSize: "20px",
            cursor: "pointer",
          }}
        >
          ✕
        </button>

        <div>
          <h4
            style={{
              marginTop: 0,
              color: "#0FB7A4",
              fontSize: "18px",
              fontWeight: "bold",
            }}
          >
            NEED HELP?
          </h4>
          <h5
            style={{
              marginTop: "-10px",
              marginBottom: "20px",
              color: "#0FB7A4",
              fontWeight: "bold",
            }}
          >
            REQUEST A CALL BACK
          </h5>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Name <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            onBlur={handleBlur}
            style={inputStyle(touched.name && errors.name)}
          />
          <span style={errorStyle}>{touched.name && errors.name}</span>

          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Mobile No. <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="tel"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength={10}
            style={inputStyle(touched.mobile && errors.mobile)}
          />
          <span style={errorStyle}>{touched.mobile && errors.mobile}</span>

          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Email address <span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            onBlur={handleBlur}
            style={inputStyle(touched.email && errors.email)}
          />
          <span style={errorStyle}>{touched.email && errors.email}</span>

          <label style={{ display: "block", marginBottom: "5px", color: "#333" }}>
            Comment <span style={{ color: "red" }}>*</span>
          </label>
          <textarea
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            onBlur={handleBlur}
            maxLength="150"
            rows="4"
            style={{
              ...inputStyle(touched.comment && errors.comment),
              resize: "none",
            }}
          ></textarea>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <span style={errorStyle}>{touched.comment && errors.comment}</span>
            <span
              style={{
                fontSize: "12px",
                color: "#555",
              }}
            >
              {formData.comment.length}/150
            </span>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "15px",
              marginTop: "20px",
            }}
          >
            <button
              type="button"
              onClick={handleReset}
              disabled={isSubmitting}
              style={{
                backgroundColor: "#706b6bff",
                color: "white",
                border: "none",
                padding: "10px 0",
                borderRadius: "4px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                width: "120px",
                textAlign: "center",
                fontSize: "15px",
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              Reset
            </button>
            <button
              type="submit"
              disabled={isSubmitting}
              style={{
                backgroundColor: "#0FB7A4",
                color: "white",
                border: "none",
                padding: "10px 0",
                borderRadius: "4px",
                cursor: isSubmitting ? "not-allowed" : "pointer",
                width: "120px",
                textAlign: "center",
                fontSize: "15px",
                opacity: isSubmitting ? 0.6 : 1,
              }}
            >
              {isSubmitting ? "Submitting..." : "Submit"}
            </button>
          </div>
        </form>
      </div>

      {successModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <div
            style={{
              backgroundColor: "#fff",
              borderRadius: "20px",
              padding: "40px 30px",
              width: "90%",
              maxWidth: "500px",
              textAlign: "center",
              boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
              animation: "fadeIn 0.3s ease",
            }}
          >
            <img
              src={rbdLogo}
              alt="RB Diagnostic"
              style={{
                width: "120px",
                marginBottom: "20px",
              }}
            />
            <p
              style={{
                fontSize: "18px",
                color: "#555",
                lineHeight: "1.5",
                marginBottom: "25px",
              }}
            >
              Thank you for contacting <b>RB Diagnostics</b>. One of our
              representatives will be in touch with you shortly.
            </p>
            <button
              onClick={() => {
                setSuccessModal(false);
                onClose();
              }}
              style={{
                backgroundColor: "#E53935",
                color: "#fff",
                border: "none",
                borderRadius: "30px",
                padding: "10px 40px",
                fontSize: "16px",
                cursor: "pointer",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
              }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
}